"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksConnectionStatus = void 0;
var QuickbooksConnectionStatus;
(function (QuickbooksConnectionStatus) {
    QuickbooksConnectionStatus["SUCCESS"] = "successful";
    QuickbooksConnectionStatus["FAILED"] = "failed";
})(QuickbooksConnectionStatus || (exports.QuickbooksConnectionStatus = QuickbooksConnectionStatus = {}));
